var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBustedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 800 755.8",
    style: {
      enableBackground: "new 0 0 800 755.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#DE0E54;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M772.6,406.4c18.5-8.9,27.4-21.6,27.4-34.4c0-12.7-8.9-24.5-27.4-30.9l-150.5-51.9l64.6-132.1 c3.5-6.7,4.5-13.7,4.5-19.7c0-17.8-13.4-30.9-30.9-30.9c-6,0-13,1-19.7,4.5l-136.5,66.8L432.8,25.5C425.1,8.6,412.7,0,400,0 c-12.4,0-24.8,8.6-32.5,25.5l-71.3,152.4l-136.5-66.8c-7-3.5-13.7-4.5-19.7-4.5c-17.5,0-31.2,13-31.2,30.9c0,6,1.3,13,4.8,19.7 l64.6,132.1L27.4,341.1C9.5,347.2,0,359.6,0,372.3c0,12.4,9.2,25.1,27.4,34l144.5,69.1l-78,165.2c-3.8,7.3-5.4,14.3-5.4,21 c0,15.9,10.8,27.4,26.1,27.4c6.4,0,13.4-2.2,20.7-6.7l184.6-109.1l50.6,156.6c6,17.2,17.5,26.1,29.6,26.1c12.7,0,23.9-8.9,29.6-26.1 l50.9-156.6l184.6,109.1c7.3,4.5,14.3,6.4,20.7,6.4c14.6,0,26.1-10.8,26.1-26.7c0-6.7-1.9-14-5.4-21.3l-78.3-165.2L772.6,406.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBustedIcon);
export default __webpack_public_path__ + "static/media/busted_icon.d1687011f5033d246eb82239339f207f.svg";
export { ForwardRef as ReactComponent };